"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _Storage = _interopRequireDefault(require("../util/Storage"));

var QA_DOT_COM = 'qa.com';
var storage;

try {
  var localStorage = window && window.localStorage ? window.localStorage : false;
  storage = new _Storage.default(localStorage);
} catch (e) {
  storage = new _Storage.default(false);
}

var env = {
  isQa: function isQa() {
    if (storage.getItem('ENV') === 'qa') {
      return true;
    }

    return document.domain.indexOf(QA_DOT_COM) >= 0;
  }
};
var _default = env;
exports.default = _default;
module.exports = exports.default;